import { useFrame } from '@react-three/fiber';
import React, { useRef } from 'react';
import { DoubleSide } from 'three';
import { Dialog } from '../../../../components';
import { powerUp } from '../../../../textures';
import { rand } from '../../../../utils';
import { PowerupEntity, PowerupType } from './game/PowerupEntity';

const t = powerUp();

const labels: { [key in PowerupType]: string } = {
  invincible: 'Invincible',
  shipSpeed: 'Speed',
  rapidFire: 'Rapid Fire',
  lifeIncrease: 'Life Increase',
};

const ControlledPowerup = ({
  powerupEntity,
}: {
  powerupEntity: PowerupEntity;
}) => {
  const meshRef = useRef<any>();
  const textRef = useRef<any>('');
  const textWrapRef = useRef<any>();
  useFrame((_, delta) => {
    t.step(delta);
    meshRef.current.rotation.x += rand(0.01, 0.08);
    meshRef.current.rotation.y += rand(0.01, 0.08);
    meshRef.current.rotation.z += rand(0.01, 0.08);

    meshRef.current.position.x = powerupEntity.position[0];
    meshRef.current.position.y = powerupEntity.position[1];
    meshRef.current.position.z = powerupEntity.position[2];

    if (powerupEntity.currentRoll) {
      textRef.current = labels[powerupEntity.currentRoll.type];
      textWrapRef.current.visible = true;
    } else if (textRef.current) {
      textRef.current = '';
      textWrapRef.current.visible = false;
    }

    meshRef.current.visible = powerupEntity.visible;
  });
  return (
    <>
      <mesh ref={meshRef} rotation={[60, 12, 12]}>
        <sphereGeometry attach="geometry" args={[4.5, 2, 2]} />
        <meshBasicMaterial
          side={DoubleSide}
          map={t?.texture}
          attach="material"
        />
      </mesh>
      <group ref={textWrapRef} position={[80, 80, 80]}>
        <Dialog
          textRef={textRef}
          text=""
          background={'black'}
          position={[0, 0, 0]}
          rotation={[1, 0, 0]}
          size={[60, 10]}
          canvasSize={[120, 20]}
          color={[255, 255, 255, 255]}
        />
      </group>
    </>
  );
};

export default ControlledPowerup;
